import type { ReactNode } from 'react';
import { usePermission } from './usePermission';
import type { PermissionCode } from '../types';

interface CanProps {
  /** Một hoặc nhiều permission code (chỉ cần có 1 là hiển thị). */
  permission: PermissionCode | PermissionCode[];
  /** Nội dung hiển thị khi có quyền. */
  children: ReactNode;
  /** Nội dung thay thế khi KHÔNG có quyền (mặc định: không render gì). */
  fallback?: ReactNode;
}

/**
 * Render children chỉ khi user có quyền tương ứng.
 * <Can permission="FEATURE_CONFIRM"><Button ... /></Can>
 */
export function Can({ permission, children, fallback = null }: CanProps): JSX.Element {
  const allowed = usePermission(permission);
  return <>{allowed ? children : fallback}</>;
}
